module.exports = __webpack_public_path__ + "img/icon_logout.56c79eb5.svg";